<template src="./html/sparking-change-quiz.html"></template>

<script>
import { quizFunctions } from "../components/functions";
import moreInfoForm from '../components/more-info-form.vue';
import globalMixin from '../mixins/global';

let quiz = {
    questions: [{
      text: "Do your learning programs support your organization’s mission?",
      group: 'Envision',
      responses: [{
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-envision.png')
    },
    {
      text: "Do your learning programs effectively cater to the needs of different audiences?",
      group: 'Envision',
      responses: [{
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-envision.png'),
    },
    {
      text: "Do your courses include multimedia and interactive content?",
      group: 'Create',
      responses: [{
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Sometimes',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-create.png'),
    },
    {
    text: "How accessible are your learning programs?",
      group: 'Create',
      responses: [
        {
          text: 'Very',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'Not Very',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-create.png')
      ,
    },
    {
      text: "Do your programs allow learners to collaborate and learn from each other?",
      group: 'Deliver',
      responses: [
        {
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-deliver.png')
      ,
    },
    {
      text: "Do you deliver learning in multiple formats (in-person, online, blended, etc.)?",
      group: 'Deliver',
      responses: [
        {
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Sometimes',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-deliver.png')
      ,
    },
    {
      text: "In general, how engaged are your learners?",
      group: 'Analyze',
      responses: [
        {
          text: 'Very',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'Not Very',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-analyze.png')
      ,
    },
    {
      text: "Do you use technology to measure, improve and communicate the impact of your learning programs?",
      group: 'Analyze',
      responses: [
        {
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-analyze.png')
      ,
    },
    {
      text: "Are learners enabled to track skills development over time?",
      group: 'Grow',
      responses: [
        {
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-grow.png')
      ,
    },
    {
      text: "Do you have strategies and tools to market and sell your learning programs? ",
      group: 'Grow',
      responses: [
        {
          text: 'Yes',
          value: '2'
        },
        {
          text: 'Somewhat',
          value: '1'
        },
        {
          text: 'No',
          value: '0'
        }
      ],
      image: require('../assets/sparking-change-grow.png')
      ,
    }
  ]
};

let types_content = {

    sections: [
      {
        section_title: 'Lightning Bug',
        hovered_content: 'Fueled by competition',
        background_colour: 'color-cinnabar',
        text_colour: 'd2lWhite',
        image: require('../assets/sparking-change-firefly.png'),
        knockout_image: require('../assets/learner-quiz-Competitor-Shadow.png'),
        social_description: "I'm a Lightning Bug! Find out your learner type here.",
        winner_content: `<p>You're ready to grow.</p><p>You have the pieces you need to make learning an impact driver for your organization. With the right partner, strategy and tools in place, you have a bright path ahead of you.</p>`,
        download_pdf: '',
        landing_page_url: '/lightning-bug',
        section_attributes: [
          // 'Setting and raising the bar',
          // 'Striving to lead the pack',
          // 'Leaderboards, awards, badges, and newsfeeds'
        ],
        products: [
          {
            name: 'Brightspace',
            link: ''
          }
        ],
        resources: [
          {
            name: 'Learning Strategy',
            link: ''
          }
        ],
        stories: []
      },
      {
        section_title: 'Flashlight',
        hovered_content: 'Driven by achievements',
        background_colour: 'color-fluorite',
        text_colour: 'd2lWhite',
        image: require('../assets/sparking-change-flashlight.png'),
        knockout_image: require('../assets/learner-quiz-Collector-Shadow.png'),
        social_description: "I'm a Flashlight! Find out your learner type here.",
        winner_content: `<p>You're on the right path.</p><p>You know how valuable learning can be in helping you advance your mission and are ready to take your programs to the next level. Having the right solutions on your side will only make your path brighter.</p>`,
        download_pdf: '',
        landing_page_url: '/flashlight',
        section_attributes: [
          // 'Uncovering hidden gems',
          // 'Growing your collection of unique, specialized distinctions',
          // 'Awards, badges, and personalized learning'
        ],
        products: [
          {
            name: 'Creator+',
            link: ''
          },
          {
            name: 'D2L Lumi',
            link: ''
          }
        ],
        resources: [
          {
            name: 'Learning Services',
            link: ''
          }
        ],
        stories: []
      },
      {
        section_title: 'Spotlight',
        hovered_content: 'Inspired by other learners',
        background_colour: 'color-celestine',
        text_colour: 'd2lWhite',
        image: require('../assets/sparking-change-spotlight.png'),
        knockout_image: require('../assets/learner-quiz-Collaborator-Shadow.png'),
        social_description: "I'm a Spotlight! Find out your learner type here.",
        winner_content: `<p>You're on the right path.</p><p>You know how valuable learning can be in helping you advance your mission and are ready to take your programs to the next level. Having the right solutions on your side will only make your path brighter.</p>`,
        download_pdf: '',
        landing_page_url: '/spotlight',
        section_attributes: [
          // 'Encouraging knowledge sharing among individuals and groups',
          // 'Contributing to the collective knowledge',
          // 'Newsfeeds, discussions, and feedback'
        ],
        products: [
          {
            name: 'Creator+',
            link: ''
          },
          {
            name: 'D2L Lumi',
            link: ''
          }
        ],
        resources: [
          {
            name: 'Learning Services',
            link: ''
          }
        ],
        stories: []
      }
    ]
};

export default {
  name: 'learner-type-quiz',

  components: {
    moreInfoForm
  },

  mixins: [quizFunctions, globalMixin],
  
  data() {
    return {
      ...this.defaultQuizData(),
      ...{
        attributes_data: [
          {
            heading: 'Strength',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path class="color-green-60_icon" d="M53,50H52a2,2,0,0,1-2-2V16A1.94,1.94,0,0,1,52,14L53,14a2,2,0,0,1,2,2V48A2,2,0,0,1,53,50Z"></path><rect class="color-green-60_icon" x="55.02" y="24" width="5" height="18" rx="2"></rect><rect class="color-green-60_icon" x="14.02" y="31" width="7" height="5"></rect><rect class="color-green-60_icon" x="43.02" y="31" width="7" height="5"></rect><path class="color-green-60_icon" d="M26.52,37V29A2.76,2.76,0,1,1,32,29v0a2.76,2.76,0,1,1,5.5,0v0A2.76,2.76,0,1,1,43,29V40c0,6.11-3.28,6-10,6s-12,.11-12-6V29c0-1.68.77-3,2.7-3a2.93,2.93,0,0,1,2.8,3v8"></path><path class="color-green-60_icon" d="M35,26V25c0-1.53.32-3,2-3h3v4"></path><path class="color-green-60_icon" d="M11,50h1a2,2,0,0,0,2-2V16a1.93,1.93,0,0,0-1.94-2L11,14a2,2,0,0,0-2,2V48A2,2,0,0,0,11,50Z"></path><rect class="color-green-60_icon" x="4.02" y="24" width="5" height="18" rx="2"></rect></svg>'
          },
          {
            heading: 'Motivator',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path class="color-green-60_icon" d="M31.58,30.54A8.15,8.15,0,1,1,29.5,32.7"></path><path class="color-green-60_icon" d="M26.1,25.49A15.43,15.43,0,1,1,24,27.73"></path><path class="color-green-60_icon" d="M20.85,20.3a22.77,22.77,0,1,1-2.21,2.32"></path><polyline class="color-green-60_icon" points="3 11 9 11 9 4 12.92 8.02 17 12 17 17 37 36 35 37 15 19 9 19 5 15"></polyline></svg>'
          },
          {
            heading: 'Top Tools',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><polyline class="color-green-60_icon" points="41 29 48 22 53 22 60 8 56 4 42 11 42 16 35 23"></polyline><line class="color-green-60_icon" x1="27" y1="43" x2="29" y2="41"></line><line class="color-green-60_icon" x1="23" y1="35" x2="21" y2="37"></line><path class="color-green-60_icon" d="M16,60l9-9-2-4,6-2L19,35l-2,6-4-2L4,48v6c0,1.87,4.13,6,6,6Z"></path><line class="color-green-60_icon" x1="59" y1="52" x2="52" y2="59"></line><rect class="color-green-60_icon" x="33.76" y="16.79" width="8.49" height="42.43" transform="translate(-15.74 38) rotate(-45)"></rect><rect class="color-green-60_icon" x="11.26" y="4.89" width="8.49" height="21.21" transform="translate(-6.42 15.5) rotate(-45)"></rect><polyline class="color-green-60_icon" points="14 8 18 4 29 15"></polyline></svg>'
          }
        ]
      },
      formHeight: null,
      formSubmitted: false
    }
  },

  methods: {
    defaultQuizData: function () {
      return {
        name:'sparking-change',
        title: 'Sparking Change',
        share_description: 'Complete this quiz to find out what your learner type is!',
        active_image_default: require('../assets/learner-quiz-QuestionMark.png'),
        active_image: require('../assets/learner-quiz-QuestionMark.png'),
        active_section: '-1',
        active_colour_default: 'd2lOrange',
        active_colour: 'd2lOrange',
        winning_colour: '',
        winning_text_colour: '',
        winning_image: '',
        winning_title: '',
        winning_attributes: [],
        winning_products: [],
        winning_services: [],
        landing_page_url: '',
        content_display: '',
        quiz_hidden: true,
        quiz: quiz,
        questionIndex: 0,
        userResponses: Array(),
        homepage_hidden: false,
        types: types_content,
        showForm: false,
        form_text: `Get your full results and claim your swag.`,
        form_thank_you_message: `Thank you! Come by the D2L booth and show this screen to claim your swag.`,
        button_text: '',
        form_id: '2042',
        salesforce_id: '7015W0000008xbaQAA',
        hide_types_on_start: true,
        start_page_description: '<h1 class="h2">How Are You Sparking Change?</h1><p>Whether it’s strengthening the community where you live or supporting people around the world, your organization is on a mission to transform lives. Your learning programs help make that happen.</p><p>But are they having the biggest impact they can?</p><p>This short quiz is here to answer that question.</p><p>Answer 10 questions and get a result that reflects the progress you’ve made to help spark hope, inspire change, and fuel growth—for your organization and the people it serves.</p>',
        start_page_quote: 'For non-profits, growth is measured by lives impacted.',
        start_page_quoter: 'Gary Flowers, CIO, Year Up United'
      }
    }
  },

  beforeCreate() {
    window.addEventListener('message', ({ data }) => {

      if (!('event' in data)) {
        return;
      }

      if (data.event === 'setHeight') {
        this.formHeight = data.height + 40
      }

      if (data.event === 'formSubmitted') {
        this.formSubmitted = true;
      }

    });
  },

  created() {

    // remove when finished
    if (this.$route.query.quiz === 'end') {
      this.questionIndex = this.quiz.questions.length - 1;
      this.userResponses = ['2', '2', '0', '0', '0', '0', '0', '0', '0', '1']
      this.next();
      return;
    }

    if ( this.isFusion() ) {
      this.form_text = `Fill out the form to get your full results.`;
      this.form_thank_you_message = `
       <p>An email with the information about your learner type will land in your inbox shortly.</p>
       <p>You can now close this dialog. If you wish to return to this screen simply click "Get my results" from the quiz.</p>
       <p class="h3 margin-top-2 text-center">Fusion Challenge Code: <span class="font-bold">QZ64</span></p>
      `;
    }

    if (this.isISTE_2024) {
      this.form_thank_you_message = `
        <p>Show this screen to a D2Ler to receive your Learner Type sticker.<p>
        </p>It is safe to close this dialog. You can return to this screen by clicking "Get my results"</p>
      `;
    }
  }
}
</script>

<style scoped>

.results-img-wrap {

  @media (max-width: 768px) {
    position: fixed;
    z-index: -1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.2;
    padding: 0;
  }
}

.sparking-change-container {
  max-width: 1000px;
  margin: 0 auto;

  p, span {
    font-family: 'D2L Sans', sans-serif;
  }

  a {
    color: var(--primary-color-50);
    text-decoration: underline;
  }
}

.learner-type-container:before {
  content: "";
  background: var(--color-green);
  position: fixed;
  width: 20px;
  bottom: 0;
  top: 0;
  right:0 ;
  transform: scaleX(-1);
}

.home-image-wrap {
  height: 300px;
  max-height: 300px;
}

@media (min-width: 769px) {
  .learner-type-container:before {
    width: 60px;
  }
}

@media (max-width: 768px) {
  #results-container {
    flex-direction: column-reverse;
  }
  #results-main-content {
    flex-direction: column-reverse;
  }
  #attribute-list li>div {
    flex-direction: column;
  }
}

.question-section,
#results-container {
  min-height: 683px;
}

.question-title {
  letter-spacing: 1rem;
}

.quote-container {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  /* gap: 10px; */
  grid-auto-flow: column;
  position: relative;
  min-height: 300px;
  
  &::before {
    display: none;
    position: absolute;
    content: "";
    background-image: url('../assets/sparking-change-gary-flowers.png');
    background-size: contain;
    background-position: right bottom;
    background-repeat: no-repeat;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    grid-column: 4 / 7;
    /* grid-row: 1 / 2; */
    z-index: 1;

    @media(min-width: 769px) {
      display: block;
    }
  }

  .quote-gradient-bg {
    top: 30px;
  }

  .start-page-quote {
    grid-column: 2 / 6;
    margin-top: 30px;
    /* grid-column: 1 / 3; // Starts at column 2 and spans to 4 */
    /* grid-row: 1 / 2; */
    z-index: 1;

    @media(min-width: 769px) {
      grid-column: 2 / 5;
    }

    @media(min-width: 1025px) {
      grid-column: 2 / 6;
    }
  }
}

.question-image-container {
  position: fixed;
  left: 0;
  z-index: -2;
  opacity: .15;

  &:before {
    content: "";
    background: linear-gradient(45deg, white, transparent);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  @media (min-width: 769px) {
    position: static;
    opacity: 1;

    &:before {
      z-index: 0;
    }
  }
}
</style>
